import React from 'react';
import MicrosoftMarkIcon from './MicrosoftMarkIcon';

/**
 * OrSeparator — a thin horizontal rule with a centered muted "or", so the
 * credentials form and the provider button read as an either/or choice. React
 * port of dview's OrSeparator.java.
 */
export const OrSeparator = ({ label = 'or' }) => (
  <div className="login-oauth-separator" data-testid="login.oauth-separator" aria-hidden="true">
    <span className="login-oauth-separator__line" />
    <span className="login-oauth-separator__label">{label}</span>
    <span className="login-oauth-separator__line" />
  </div>
);

/**
 * OauthProviderButton — a full-width, enterprise-auth-style provider button
 * (dark neutral fill + brand glyph left of the label). Provider-generic like
 * dview's OauthProviderButton.java; LoginView wires the Microsoft label + glyph.
 *
 * @param {Object} props
 * @param {string} props.label - e.g. "Sign in with Microsoft"
 * @param {React.ReactNode} [props.icon] - the provider mark (defaults to Microsoft)
 * @param {function} props.onClick
 * @param {boolean} [props.disabled]
 * @param {string} [props.testId='login.microsoft']
 */
const OauthProviderButton = ({
  label,
  icon = <MicrosoftMarkIcon size={18} />,
  onClick,
  disabled = false,
  testId = 'login.microsoft',
}) => (
  <button
    type="button"
    /* NOT `hoverable`: that setup-utility class forces `color: black` (App.css) with equal
       specificity to .login-oauth-button, and being later in source order it won its `color`,
       painting black text on the dark #373737 fill (unreadable). The button styles its own
       color + :hover already. (#86bb7phhh) */
    className="login-oauth-button"
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
  >
    <span className="login-oauth-button__icon">{icon}</span>
    <span className="login-oauth-button__label">{label}</span>
  </button>
);

export default OauthProviderButton;
